<template>
  <div class="space-y-6" novalidate>
    <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
      <InputField
        :label="$t('form.name')"
        id="name"
        :value="formData.name"
        @input="updateField('name', $event)"
        :error="errors.name"
        :required="true"
      />
      <InputField
        :label="$t('form.email')"
        id="email"
        :value="formData.email"
        @input="updateField('email', $event)"
        :error="errors.email"
        :required="true"
      />
    </div>

    <InputField
      :label="$t('form.order_id')"
      id="order_id"
      :value="formData.order_id"
      @input="formatOrderNumber($event)"
      placeholder="XXX-XXXXXXX-XXXXXXX"
      :error="errors.order_id"
      :helpText="$t('form.orderNumberHelp')"
      @helpTextClick="helpTextClick"
      :maxlength="19"
      :required="true"
    />

    <!-- <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
      <div>
        <label for="comment" class="block mb-2 font-semibold">
          {{ $t("form.describeIssue") }}  <span class="text-brand-red">*</span>
        </label>
        <textarea
          id="comment"
          name="comment"
          :value="formData.comment"
          @input="updateField('comment', $event.target.value)"
          rows="6"
          :class="[
            'w-full p-3 bg-white border rounded-2xl outline-none focus:ring-2 focus:ring-brand-red/50 focus:border-brand-red transition-all',
            errors.comment ? 'border-red-500' : 'border-gray-200',
          ]"
        ></textarea>
        <p class="mt-1 text-xs text-brand-gray">
          {{ $t("form.commentHelp") }}
        </p>
        <p v-if="errors.comment" class="mt-1 text-xs text-red-500">
          {{ errors.comment }}
        </p>
      </div>
      <div>
        <label class="block mb-2 font-semibold"
          >{{ $t("form.fileUpload") }}
          </label
        >
        <div
          :class="[
            'bg-white p-4 border rounded-2xl',
            errors.files ? 'border-red-500' : 'border-gray-200',
          ]"
        >
          <label
            for="file-upload"
            :class="[
              'flex flex-col items-center justify-center w-full py-6 border-2 border-gray-300 border-dashed rounded-xl cursor-pointer bg-gray-50 hover:bg-gray-100 transition-colors',
            ]"
            @dragover.prevent
            @drop.prevent="onDrop"
          >
            <div class="flex flex-col justify-center items-center text-center">
              <UploadIcon />
              <i18n
                path="form.fileUploadInstructions"
                tag="p"
                class="mb-2 text-sm text-brand-gray"
              >
                <span slot="action" class="font-semibold text-brand-red">{{
                  $t("form.fileUploadInstructionsAction")
                }}</span>
              </i18n>
              <p class="text-xs text-gray-500">
                {{ $t("form.fileUploadLimit") }}
              </p>
            </div>
            <input
              id="file-upload"
              type="file"
              class="hidden"
              multiple
              @change="handleFileChange"
              accept="image/*,video/*,.xlsx,.pdf,.xls,.docx,.doc,.ppt,.pptx"
            />
          </label>
          <div class="mt-4 space-y-3" v-if="formData.files.length > 0">
            <div
              v-for="file in formData.files"
              :key="file.id"
              class="p-2.5 bg-white rounded-lg border border-gray-200"
            >
              <div class="flex gap-3 items-center">
                <img
                  :src="file.previewUrl"
                  class="object-cover flex-shrink-0 w-12 h-12 bg-gray-200 rounded-md"
                />
                <div class="overflow-hidden flex-grow">
                  <p class="text-sm font-semibold truncate text-brand-dark">
                    {{ file.name }}
                  </p>
                  <p class="text-xs text-brand-gray">{{ file.size }}</p>
                </div>
                <button
                  v-if="file.state === 'completed'"
                  @click.prevent="removeFile(file.id)"
                  class="flex-shrink-0 p-1 text-gray-400 hover:text-brand-red"
                >
                  <CloseIcon />
                </button>
              </div>
              <div
                v-if="file.state === 'uploading'"
                class="mt-2 w-full h-1 bg-gray-200 rounded-full"
              >
                <div
                  class="h-1 rounded-full transition-all duration-300 bg-brand-red"
                  :style="{ width: file.progress + '%' }"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <p v-if="errors.files" class="mt-1 text-xs text-red-500">
          {{ errors.files }}
        </p>
      </div>
    </div>

    <div>
      <label for="survey" class="block mb-2 font-semibold"
        >{{ $t("form.surveyTitle") }}
       </label
      >
      <textarea
        id="survey"
        name="survey"
        :value="formData.survey"
        @input="updateField('survey', $event.target.value)"
        rows="3"
        :placeholder="$t('form.surveyPlaceholder')"
        :class="[
          'w-full p-3 bg-white border border-gray-200 rounded-2xl outline-none focus:ring-2 focus:ring-brand-red/50 focus:border-brand-red transition-all',
          errors.survey ? 'border-red-500' : 'border-gray-200',
        ]"
      ></textarea>
      <p v-if="errors.survey" class="mt-1 text-xs text-red-500">
        {{ errors.survey }}
      </p>
    </div> -->

    <div class="pt-6 text-center">
      <button
        @click.prevent="onNext"
        :disabled="loading"
        class="px-12 py-3 font-bold text-white rounded-full transition-transform bg-brand-red hover:bg-opacity-90 hover:scale-105"
        :class="{'opacity-75 cursor-not-allowed': loading}"
      >
        <SpinnerIcon v-if="loading" />
        <span v-else>{{ $t('form.nextButton') }}</span>
      </button>
    </div>
  </div>
</template>
<script>
import InputField from "./inputField.vue";
import { UploadIcon, CloseIcon,SpinnerIcon } from "./icons/";

export default {
  name: "FormStep1",
  components: {
    InputField,
    UploadIcon,
    CloseIcon,
    SpinnerIcon
  },
  props: {
    formData: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    loading: {
        type: Boolean,
        default: false
    }
  },
  methods: {
    helpTextClick() {
      this.$router.push("/order-flow");
    },
    updateField(key, value) {
      this.$emit("update-form-data", { [key]: value });
    },
    formatOrderNumber(value) {
      // Remove all non-digit characters and limit to 17 digits
      const digits = value.replace(/\D/g, "").substring(0, 17);

      let formatted = digits;
      if (digits.length > 3) {
        formatted = `${digits.slice(0, 3)}-${digits.slice(3)}`;
      }
      if (digits.length > 10) {
        formatted = `${digits.slice(0, 3)}-${digits.slice(
          3,
          10
        )}-${digits.slice(10)}`;
      }

      this.$emit("update-form-data", { order_id: formatted });
    },
    handleFileChange(e) {
      const target = e.target;
      if (target.files) {
        this.addFiles(target.files);
      }
      target.value = "";
    },
    onDragOver(e) {
      e.preventDefault();
    },
    onDrop(e) {
      e.preventDefault();
      if (e.dataTransfer?.files) {
        this.addFiles(e.dataTransfer.files);
      }
    },
    addFiles(fileList) {
      const currentFiles = this.formData.files;
      if (currentFiles.length + fileList.length > 5) {
        alert(this.$t("form.maxFilesError"));
        return;
      }

      const newFiles = Array.from(fileList).map((file) => ({
        id: Date.now() + Math.random(),
        file: file,
        name: file.name,
        size: this.formatFileSize(file.size),
        previewUrl: URL.createObjectURL(file),
        progress: 0,
        state: "uploading",
      }));

      this.$emit("update-files", [...currentFiles, ...newFiles]);

      newFiles.forEach((file) => this.simulateUpload(file));
    },
    removeFile(fileId) {
      const fileToRemove = this.formData.files.find((f) => f.id === fileId);
      if (fileToRemove) {
        URL.revokeObjectURL(fileToRemove.previewUrl);
      }
      this.$emit("remove-file", fileId);
    },
    simulateUpload(fileToUpload) {
      const interval = setInterval(() => {
        const fileInArray = this.formData.files.find(
          (f) => f.id === fileToUpload.id
        );
        if (fileInArray) {
          if (fileInArray.progress >= 100) {
            fileInArray.state = "completed";
            clearInterval(interval);
          } else {
            fileInArray.progress += Math.floor(Math.random() * 15) + 5;
            if (fileInArray.progress > 100) fileInArray.progress = 100;
          }
          // We need to force Vue to react to this deep change
          this.$emit("update-files", [...this.formData.files]);
        } else {
          clearInterval(interval);
        }
      }, 200);
    },
    formatFileSize(bytes, decimals = 1) {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
    onNext() {
      this.$emit("next-step");
    },
  },
};
</script>
